import { Button, Form } from 'antd';
import { Rule } from 'antd/es/form';
import { Country } from 'entities/countries/model/types';
import { SignUpFormData } from 'pages/auth/registration/model/types';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import PhoneInput from 'shared/ui/PhoneInput/PhoneInput';

type Props = {
  countries: Country[];
  formRules: Record<string, Rule[]>;
  formData: Partial<SignUpFormData>;
};

export const PhoneSection: FC<Props> = ({ countries, formRules, formData }) => {
  const { formatMessage: t } = useIntl();
  const [form] = Form.useForm();

  return (
    <Form form={form} name="phone">
      <Form.Item
        name="phone"
        rules={[
          {
            validator: (_, value) => {
              if (!value || value.haveErrors) {
                return Promise.reject(
                  new Error(t({ id: 'schemas.validation.phone.invalid' }))
                );
              }
              return Promise.resolve();
            },
          },
        ]}
      >
        <PhoneInput
          countries={countries}
          onChange={(state) => form.setFieldValue('phone', state)}
        />
      </Form.Item>

      <Form.Item>
        <Button
          variant="link"
          type="link"
          ghost
          block
          href="https://lmt.lmt.lv/en/karte-esim"
          target="_blank"
        >
          {t({ id: 'auth.buyEuropeanNumber' })}
        </Button>
      </Form.Item>

      <Form.Item>
        <Button color="primary" variant="solid" htmlType="submit" block>
          {t({ id: 'buttons.next' })}
        </Button>
      </Form.Item>
    </Form>
  );
};
